export const WHATSAPP_VIDEO_MIME_TYPES = [
  "video/mp4;codecs=avc1,mp4a",
  "video/mp4",
  "video/webm;codecs=vp9,opus",
  "video/webm;codecs=vp8,opus",
  "video/webm",
] as const;

export const pickVideoMimeType = (): string =>
  WHATSAPP_VIDEO_MIME_TYPES.find((t) => MediaRecorder.isTypeSupported(t)) ?? "";

export const isMp4Video = (blob: Blob, mimeType?: string): boolean => {
  const type = mimeType ?? blob.type;
  return type.includes("mp4");
};
